const DescriptionsItem = ({ children }) => children;
export default DescriptionsItem;
